module.exports = __webpack_public_path__ + "img/4.3e852cf6.png";